import { z } from "zod";

export const PROVIDER_LISTINGS_QUERY_MAX_LENGTH = 80;

export const providerListingsQueryContract = z
    .string()
    .transform((value) =>
        [...value.trim()].slice(0, PROVIDER_LISTINGS_QUERY_MAX_LENGTH).join(""),
    );

export const providerListingsPageInputContract = z.object({
    providerId: z.string().min(1),
    page: z.number().int().min(0).optional(),
    limit: z.number().int().min(1).optional(),
    query: providerListingsQueryContract.optional(),

    includeRecentlyAdopted: z.boolean().optional(),
});

export type ProviderListingsPageInput = z.input<
    typeof providerListingsPageInputContract
>;

export type ParsedProviderListingsPageInput = z.output<
    typeof providerListingsPageInputContract
>;
